@if (!excludeButtons.includes('go-to-login')) {
  <a
    routerLink="../login"
    class="button small white"
  >
    Go Back to Login
  </a>
}

<!--<a-->
<!--  routerLink="../recover-password"-->
<!--  class="button small white"-->
<!--  *ngIf="!excludeButtons.includes('forgot-username')"-->
<!--&gt;-->
<!--  Forgot Username-->
<!--</a>-->

@if (!excludeButtons.includes('forgot-password')) {
  <a
    routerLink="../reset-password"
    class="button small white"
  >
    Forgot Password
  </a>
}

<!--<a-->
<!--  routerLink="../register-user"-->
<!--  class="button small white"-->
<!--  *ngIf="!excludeButtons.includes('need-register')"-->
<!--&gt;-->
<!--  Need To Register-->
<!--</a>-->

<!--<a-->
<!--  href="https://help.motion.cloud"-->
<!--  target="_blank"-->
<!--  class="button small white"-->
<!--  *ngIf="!excludeButtons.includes('need-help')"-->
<!--&gt;-->
<!--  Need More Help-->
<!--</a>-->
